import { render } from "./PaymentLinkView.vue?vue&type=template&id=cc5051f0"
import script from "./PaymentLinkView.vue?vue&type=script&lang=js"
export * from "./PaymentLinkView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__